TS.ns('WL');

WL.leasingDocumentDetailPropertiesViewModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var propertyList = me.getDomainProperty('PropertyList');

        if (propertyList) {
            propertyList.on('beforeAdd', me.onBeforePropertyAdded);
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
            propertyList.on('beforeDelete', me.onPropertyIsDeleted);
            propertyList.on('cellBeginEdit', me.onPropertyCellBeginEdit)
        }

        me.watchProperty(me.Document["CouponsNo"], me._afterCouponsNoChanged, me, false);
    },

    onBeforePropertyAdded: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;

        if (owner.ReadOnlyProperties())
            e.preventDefault();
    },

    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
        rec.IsReadOnlyProperty = new ko.observable(false);
    },
 
    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    },

    onPropertyCellBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;
        if ((e.fieldName == 'PropertyId' || e.fieldName == 'PropertyValueDynamic') && (e.record.IsReadOnlyProperty() || owner.ReadOnlyProperties()))
            e.preventDefault();
    },

    onPropertyIsDeleted: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.item.IsReadOnlyProperty() || owner.ReadOnlyProperties()) {
            e.preventDefault();
        }
    },

    _afterCouponsNoChanged: function () {
        var me = this;

        if (me.Document.CouponsNo() > 0 && me.EcobonusProperty() > 0) {
            me.Document.EcobonusAmount(me.EcobonusProperty());
        }
        else {
            me.Document.EcobonusAmount(0);
        }

        
    }
});